import { Accordion } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ViewDrawerWrapper = styled('div')({
  width: '100%',
})

export const BtnWrapper = styled('div')({
  display: 'flex',
  gap: 5,
  alignItems: 'center',
  justifyContent: 'flex-end',
})

export const ContentWrapper = styled('div')(({ theme }) => ({
  marginTop: 15,
  color: theme.palette.text.primary, //'#0F1222'
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  h4: {
    fontWeight: 500,
    fontSize: '20px',
    margin: 0,
  },
  p: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
  },
}))

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  svg: {
    color: theme.palette.grey[500],
  },
}))

export const DateWrapper = styled('div')(({ theme }) => ({
  padding: '8px',
  borderRadius: theme.shape.customBorderRadius.main,
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(35, 97, 146, 0.08)', //theme.palette.primary.light
  color: theme.palette.primary.main, //theme.PRIMARY,
  gap: 10,
  fontWeight: 500,
  fontSize: '14px',
  width: 'max-content',
}))

export const WrapperHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '10px 0px 5px 0px',
  h4: {
    fontWeight: 500,
    fontSize: '16px',
    color: theme.palette.text.primary, //'#0F1222'
  },
}))

export const TitleShowDown = styled(Accordion)(({ theme }) => ({
  background: 'inherit',
  boxShadow: 'none',
  margin: '0px 0px 10px',
  ':before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    background: theme.palette.grey[100], //'#F5F5F5'
    borderRadius: theme.shape.customBorderRadius.main,
    '& .Mui-expanded': {
      margin: 0,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
    background: theme.palette.grey[100], //'#F5F5F5'
  },
}))

export const AccordionContentWrapper = styled('div')({
  marginLeft: 'auto',
  padding: '10px 25px 10px 45px',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  p: {
    fontWeight: 400,
    fontSize: '14px',
  },
})

export const ModalBody = styled('div')({
  fontSize: '16px',
  fontWeight: '400',
  margin: '25px 0px',
})

export const ActivityAccordion = styled(TitleShowDown)({
  '& .MuiAccordionSummary-root': {
    background: 'transparent',
    padding: 0,
  },
  '& .MuiAccordionDetails-root': {
    background: 'transparent',
  },
})

export const ActivityCard = styled('div')(({ theme }) => ({
  background: theme.palette.grey[100], //'#F5F5F5'
  padding: '8px',
  borderRadius: theme.shape.customBorderRadius.main,
  marginBottom: '8px',
  fontWeight: 400,
  '& .title': {
    fontSize: '14px',
  },
  '& .content': {
    fontSize: '12px',
    color: theme.palette.grey[500], //'#979797'
  },
}))

export const LoadingSubTask = styled('div')({
  display: 'flex',
  padding: '4px',
})

export const BackButtonWrapper = styled('div')({
  display: 'flex',
  flex: 1,
  justifyContent: 'flex-start',
})
